import { render } from "./FileUpload.vue?vue&type=template&id=375a86ca"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/primevue/FileUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "375a86ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('375a86ca', __exports__)) {
    api.reload('375a86ca', __exports__)
  }
  
  module.hot.accept("./FileUpload.vue?vue&type=template&id=375a86ca", () => {
    api.rerender('375a86ca', render)
  })

}


export default __exports__